import Vue from 'vue';

export default (type = 'createOrUpdate', params = {}) => (
  new Promise((resolve, reject) => {
    let request = null;
    if (type === 'createOrUpdate') {
      request = Vue.$http.post('organization_settings/email_for_invoice_copy', params);
    } else if (type === 'display') {
      request = Vue.$http.get('organization_settings/email_for_invoice_copy');
    }
    request.then((response) => {
      resolve(response.data);
    })
    .catch((error) => {
      reject(error.response.data);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/organizationSettings/emailInvoiceCopy.js